<template>
  <div>
    <h3>Your Permit Application Has Been Saved</h3>
    <p>
      Your permit application has been saved. Your application number is {{applicationNumber}}. You can use this number
      to retrieve and complete your application.
    </p>
    <p>
      You will receive an email confirmation shortly.
    </p>
  </div>
</template>

<script>
export default {
  name: 'OpenBurnPermitApplicationSaved',
  computed: {
    applicationNumber() {
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'applicationId') && this.$route.query.applicationId) {
        return this.$route.query.applicationId;
      }
      return '';
    },
  },
};
</script>
